module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAVCAMAAACuRUSFAAAAVFBMVEUAAACrq6upqamqqqqqqqqqqqqqqqqqqqqurq6qqqqsrKypqamqqqqrq6uqqqqrq6uqqqqpqampqamqqqqpqampqamqqqqrq6upqamrq6uxsbGpqakWiFgVAAAAG3RSTlMAiHqyUMjsOyHcGqeEVGpH9eXZwqSek3ZfQA0w9NXsAAAAg0lEQVQY033LSRLDIAxE0cYgEGA8Ox64/z2DQ7nQKn8jvUWjpqxCayQfPI14Wqy1U2RwnMq3IIf+02tjjC43ZGR06tJPl+pQDYABNJsyNcJ04iThwa52EAaPDOmStPbea+GQhhSEEdf4b78R0SbMzjl+fcxUm4+fb/d2P06mlTJ2Ldu/VTsIl0plQFgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/pedidos.png
// module id = 527
// module chunks = 0